import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import linearInfo from '../../assets/img/linear_info.svg';
import { CaiInfoModal } from "../../components/cai-info-modal/CaiInfoModal";
import { LinearInfoModal } from "../../components/cai-info-modal/LinearInfoModal";
import CaiPreviewsCmp from "../../components/cai-preview/CaiPreviewsCmp";
import AuthConfirmCancelProcedureModal from "../../components/cancel-authorize-confirm-claim-modal/AuthConfirmCancelProcedureModal";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { RealtimeModal } from "../../components/modal/RealtimeModal";
import { LNextButton, NextButton, SecondChoiseButton } from "../../components/styled/Button.style";
import { LTitleIconSection, Section } from "../../components/styled/Containers.style";
import { InfoIcon, LIconContainer } from "../../components/styled/Icon.style";
import { Vspace } from '../../components/styled/Separators.style';
import { LPageTitle, LSimpleText, PageTitle, TextDefault } from "../../components/styled/Text.style";
import { AUTH_CONFIRM_BASE_ROUTH, AUTH_CONFIRM_PATHS } from "../../routes/AuthConfirmRouter";
import { LINEAR_BASE_ROUTE } from "../../routes/linearRouteConstants";
import { selectCommunicationData } from "../../store";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { CommunicationType, EventCommType, EventValueEnum, UserRoleEnum } from "../../types/communication/communicationDataType";
import { usePrivacyCheckCmp } from "../../utils/hooks/usePrivacyCheckCmp";
import { composeUrl } from "../../utils/utils";
import PageContainerCmp from "../PageContainerCmp";

/* istanbul ignore next */
const AuthConfirmCaiPreviewPage = () => {
    const dispatch = useAppDispatch();
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    let navigate = useNavigate();
    let { token } = useParams();
    const { privChecked, PrivCheckedCmp } = usePrivacyCheckCmp(communication.authConfirmPrivacyChecked, communication?.companyName)

    const previewToken = communication.userRole === UserRoleEnum.USER_1 ? communication.token : communication.mainUserToken
    const previewUrlPage_1 = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${previewToken}/dinamica-attachment-cai-data/full-page`;
    const previewUrlPage_2 = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${previewToken}/dinamica-attachment-cai-data/second-full-page`;
    const msgPage = communication.userRole === UserRoleEnum.USER_1 ?
        'Le informazioni del sinistro che ci hai condiviso sono state inserite nel modulo di constatazione amichevole che vedi qui sotto.' :
        'La controparte ha compilato la Constatazione Amichevole relativa al sinistro in cui sei coinvolto, di cui puoi visualizzare l\'anteprima:'

    const [openCaiModal, setOpenCaiModal] = useState(false)
    const [cancelModalOpened, setCancelModalOpened] = useState<boolean>(false)

    const shouldDisableButton = () => {
        return !(privChecked?.value);
    }

    const goToNextStepHandler = () => {
        /* istanbul ignore next */
        const baseRoute = communication?.companyName === "LINEAR" ? `${LINEAR_BASE_ROUTE}/${AUTH_CONFIRM_BASE_ROUTH}` : `${AUTH_CONFIRM_BASE_ROUTH}`;
        const _pathname = composeUrl(token, AUTH_CONFIRM_PATHS.AUTHORIZE_CHOOSE_SIGNATURE_AUTHENTICATION, baseRoute)
        /* istanbul ignore next */
        const newEvent = new EventCommType({ value: EventValueEnum.AUTH_CONFIRM_PREVIEW_ACCEPTED })
        const data = new CommunicationType({
            ...communication,
            authConfirmPrivacyChecked: privChecked.value
        })
        /* istanbul ignore next */
        dispatch(saveCommunicationAct({
            events: [newEvent],
            data,
            callback: () => {
                navigate(_pathname)
            }
        })
        )
    }

    const isLinear = communication?.companyName === "LINEAR";

    return (
        <>
            <AuthConfirmCancelProcedureModal
                companyName={communication?.companyName}
                modalOpened={cancelModalOpened}
                onCloseHandler={() => setCancelModalOpened(false)} />

            {isLinear === false && <RealtimeModal
                companyName={communication?.companyName}
                modalOpened={openCaiModal}
                hTitle="Constatazione amichevole"
                hCloseButton={true}
                onCloseHandler={() => setOpenCaiModal(false)}>
                <CaiInfoModal />
            </RealtimeModal>}

            {isLinear === true && <RealtimeModal
                companyName={communication?.companyName}
                modalOpened={openCaiModal}
                hTitle="MODULO DI CONSTATAZIONE AMICHEVOLE DIGITALE"
                hCloseButton={true}
                /* istanbul ignore next */
                onCloseHandler={() => setOpenCaiModal(false)}>
                <LinearInfoModal
                    text={"È il modulo di denuncia del sinistro in formato digitale: lo trovi compilato con le informazioni del tuo sinistro. Verifica i dati e procedi con la firma digitale."}
                />
            </RealtimeModal>}

            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CAI_PREVIEW}
                removeNextBtn
                eventsOnLoad={[EventValueEnum.AUTH_CONFIRM_PLATE_CHECK_SUCCESS]}
                backPath={isLinear === true
                    ? AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CLAIM
                    : (communication.userRole === UserRoleEnum.USER_1
                        ? AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CTP_NUMBER
                        : AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CLAIM)
                }
            >

                <Section linear={isLinear}>
                    {isLinear === false && <>
                        <PageTitle>Constatazione amichevole <InfoIcon icon={faCircleInfo} onClick={() => setOpenCaiModal(true)} /></PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered sm>{msgPage}</TextDefault>
                    </>}
                    {isLinear === true && <>
                        <LTitleIconSection>
                            <LPageTitle>MODULO DI CONSTATAZIONE AMICHEVOLE</LPageTitle>
                            <LIconContainer onClick={() => setOpenCaiModal(true)}>
                                <img
                                    src={linearInfo}
                                    alt="Icon Info"
                                    style={{ width: "23px" }}
                                />
                            </LIconContainer>
                        </LTitleIconSection>

                        <Vspace qty={2}></Vspace>

                        <LSimpleText>La controparte ha compilato la Constatazione Amichevole relativa al sinistro in cui sei coinvolto. Visualizza l’anteprima:</LSimpleText>

                        <Vspace qty={2}></Vspace>
                    </>}
                </Section>

                <Section linear={isLinear}>
                    <CaiPreviewsCmp
                        previewUrlPage_1={previewUrlPage_1}
                        previewUrlPage_2={previewUrlPage_2}
                        isCaiSecondPageVisible={!!communication?.previewSecondPageVisible}
                    ></CaiPreviewsCmp>
                </Section>

                {PrivCheckedCmp}

                <Section linear={isLinear}>
                    {isLinear === false ? <>
                        <Vspace></Vspace>
                        <NextButton
                            disabled={shouldDisableButton()}
                            onClick={goToNextStepHandler}>Procedi</NextButton>
                        <Vspace></Vspace>
                    </> : <>
                        <Vspace></Vspace>
                        <LNextButton
                            disabled={shouldDisableButton()}
                            onClick={goToNextStepHandler}>Procedi</LNextButton>
                        <Vspace qty={2}></Vspace>
                    </>}
                    <SecondChoiseButton linear={!!isLinear} onClick={() => setCancelModalOpened(true)}>Non voglio firmare</SecondChoiseButton>
                </Section>

                {isLinear && <LinearFooterCmp />}

            </PageContainerCmp>
        </>

    )
}

export default AuthConfirmCaiPreviewPage;
